import { Modal, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import UPButton from 'components/button';

export const AddMotiveExceptionButton = styled(UPButton)(() => ({
  margin: '16px 16px 16px 0px',
}));

export const ModalWrapper = styled(Modal)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '600px',
  maxHeight: '650px',
  height: 'auto',
  '.MuiBackdrop-root': {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    position: 'relative',
  },
  [theme.breakpoints.down(611)]: {
    width: '90%',
  },
}));

export const ModalHeader = styled(Box)(() => ({
  position: 'sticky',
  top: 0,
  backgroundColor: 'white',
  padding: '32px 32px 20px 32px',
  zIndex: 999,
  borderTopRightRadius: '8px',
  borderTopLeftRadius: '8px',
}));

export const ModalContainer = styled(Box)(() => ({
  width: '100%',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  background: 'rgb(250, 250, 250)',
  borderRadius: '8px',
  border: 'none',
  maxHeight: '650px',
  overflowY: 'auto',
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 16,
  textAlign: 'left',
}));

export const ModalFooter = styled(Box)(() => ({
  backgroundColor: 'white',
  padding: '12px 0px',
  display: 'flex',
  gap: '16px',
  justifyContent: 'center',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
}));

export const ModalCloseIcon = styled(Box)(() => ({
  position: 'absolute',
  right: 32,
  top: 32,
  width: 24,
  height: 24,
  cursor: 'pointer',
}));

export const FormRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '10px 32px',
}));

export const ErrorText = styled(Typography)(() => ({
  color: '#D32F2F',
  fontSize: '13px',
}));
